import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
    id: 'WIFI',
    analyticsName: 'WiFi',
    queryKey: 'f_wifi',
    type: FILTER_TYPES.BOOLEAN,
    bucketify: (hotel) => {
        const facts = hotel?.hotelFacts;


        if (!facts || !facts.length) {
            return {
                bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
                bucketName: 'wifi'
            };
        }

        for (let i = 0; i < facts.length; ++i) {
            const fact = facts[i];

            if (fact && fact.id === 'hasInternet') {
                return {
                    bucketId: fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE,
                    bucketName: 'wifi'
                };
        // return fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE;
            }
        }

        return {
            bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
            bucketName: 'wifi'
        };
    },
    toQuery: ({ value }) => {
        return value ? 1 : undefined;
    },
    fromQuery: (rawQueryValue) => {
        return {
            [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue
        };
    }
}));
